import { render, staticRenderFns } from "./FollowUpForm.vue?vue&type=template&id=36435718&"
import script from "./FollowUpForm.vue?vue&type=script&lang=js&"
export * from "./FollowUpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports